import React from 'react';
import { Linking, Pressable, Platform } from 'react-native';
import styled from '@emotion/native';
import { accent, green, sand } from '@/shared/styles/colors';
import { IS_WEB, EMME_APP_STORE_URL } from '@/shared/constants/utility';
import { ROUTES } from '@/shared/constants/routes';
import { useRouter } from 'expo-router';

const StylistPreviewHeader = () => {
  const router = useRouter();

  const handleNotificationPress = () => {
    if (IS_WEB) {
      // For web, always link to App Store
      Linking.openURL(EMME_APP_STORE_URL);
    } else {
      // For mobile, determine platform
      if (Platform.OS === 'ios') {
        Linking.openURL(EMME_APP_STORE_URL);
      } else if (Platform.OS === 'android') {
        // TODO: Add Play Store URL when available
        Linking.openURL(EMME_APP_STORE_URL);
      }
    }
  };

  const handleLogoPress = () => {
    router.push(ROUTES.WELCOME.path);
  };

  return (
    <HeaderContainer>
      <Pressable onPress={handleLogoPress}>
        <Logo source={require('@/assets/images/EmmeLogo.png')} />
      </Pressable>
      <IconsContainer>
        <Pressable onPress={handleNotificationPress}>
          <MessageIcon source={require('@/assets/images/ChatIcon.png')} />
        </Pressable>
        <Pressable onPress={handleNotificationPress}>
          <MessageIcon
            source={require('@/assets/images/NotificationIcon.png')}
          />
        </Pressable>
      </IconsContainer>
    </HeaderContainer>
  );
};

export default StylistPreviewHeader;

const HeaderContainer = styled.View({
  width: '100%',
  height: IS_WEB ? 80 : 100,
  backgroundColor: green,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingHorizontal: 32,
  paddingTop: IS_WEB ? 0 : 44,
  borderBottomWidth: 1,
  borderBottomColor: accent,
});

const Logo = styled.Image({
  width: 90,
  height: 29,
  resizeMode: 'contain',
});

const IconsContainer = styled.View({
  flexDirection: 'row',
  gap: 23,
});

const MessageIcon = styled.Image({
  tintColor: sand,
  height: 20,
  width: 21,
  resizeMode: 'contain',
});
